"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserDataService = void 0;
const types_1 = require("../../shared/types");
class UserDataService {
    constructor(userDataClient) {
        this.userDataClient = userDataClient;
    }
    /**
     *
     * @param vin
     * @param pictures set to true if you need the image of the profile picture for every user (default false)
     * @param roles set to list of roles if you need just this in the response (default all roles)
     */
    async getUserData(vin, pictures, roles) {
        return await this.userDataClient.getUserData(vin, pictures, roles);
    }
    // /**-
    //  * @deprecated The method should not be used, see {@link getUserData} with role PRIMARY_USER and pictures true
    //  */
    async getPrimaryUser(vehicle) {
        const allUsers = await this.userDataClient.getUserData(vehicle.vin, vehicle.devicePlatform === types_1.DevicePlatform.WCAR);
        const primaryUser = allUsers.find((user) => user.role === 'PRIMARY_USER');
        if (primaryUser) {
            return {
                userId: primaryUser.userId,
                nickname: primaryUser.nickname,
                picture: primaryUser.picture,
                name: primaryUser.name,
                role: types_1.Role.PRIMARY_USER,
            };
        }
        return undefined;
    }
    // /**
    //  * @deprecated The method should not be used, see {@link getUserData} with pictures true
    //  */
    async getAllUsers(vehicle) {
        const allUsers = await this.userDataClient.getUserData(vehicle.vin, vehicle.devicePlatform === types_1.DevicePlatform.WCAR);
        return allUsers.map(this.adjustUserRole).sort(this.sortByRoleAndUserId);
    }
    adjustUserRole(userDataResponse) {
        var _a;
        const role = (_a = types_1.Role[userDataResponse.role]) !== null && _a !== void 0 ? _a : types_1.Role.UNKNOWN;
        return {
            name: userDataResponse.name,
            role,
            nickname: userDataResponse.nickname,
            picture: userDataResponse.picture,
            userId: userDataResponse.userId,
        };
    }
    sortByRoleAndUserId(user1, user2) {
        if (user1.role === types_1.Role.PRIMARY_USER ||
            (user1.role === types_1.Role.SECONDARY_USER && user2.role === types_1.Role.GUEST_USER)) {
            return -1;
        }
        if (user2.role === types_1.Role.PRIMARY_USER ||
            (user2.role === types_1.Role.SECONDARY_USER && user1.role === types_1.Role.GUEST_USER)) {
            return 1;
        }
        return user1.userId.localeCompare(user2.userId.toString());
    }
}
exports.UserDataService = UserDataService;
//# sourceMappingURL=UserDataService.js.map